import React, { useState } from "react";
import { FaXTwitter, FaCopy, FaFacebookF, FaWhatsapp } from "react-icons/fa6";
import "./ShareButton.scss";
import { FaShareAlt } from "react-icons/fa";
import { FiShare2 } from "react-icons/fi";
import ReactGA from "react-ga4";

function ShareButton() {
  const [showShareOption, setShowShareOptions] = useState(false);

  const shareClick = () => {
    ReactGA.event({
      category: "User",
      action: "Clicked the share button",
      label: "Share button",
    });
    setShowShareOptions(!showShareOption);
  };

  const copyLink = () => {
    ReactGA.event({
      category: "User",
      action: "Clicked the copy link button",
      label: "Copy link button",
    });
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => alert("Link copied to clipboard!"))
      .catch((err) => alert("Failed to copy link."));
  };

  const shareToFacebook = () => {
    ReactGA.event({
      category: "User",
      action: "Clicked the share to Facebook button",
      label: "Facebook button",
    });
    const url = window.location.href;
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const shareToTwitter = () => {
    ReactGA.event({
      category: "User",
      action: "Clicked the share to X button",
      label: "X button",
    });
    const url = window.location.href;
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const shareToWhatsApp = () => {
    ReactGA.event({
      category: "User",
      action: "Clicked the share to WhatsApp button",
      label: "WhatsApp button",
    });
    const url = window.location.href;
    const message = `Check this out: ${url}`;
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };
  

  return (
    <div className="share-button-container">
      <div className={`section1 ${showShareOption ? "show" : "hide"}`}>
        <button className="whatsappbtn" onClick={shareToWhatsApp}>
          <FaWhatsapp className="shareIcon" />
        </button>
      </div>
      <div className={`section1 ${showShareOption ? "show" : "hide"}`}>
        <button className="fbbutton" onClick={shareToFacebook}>
          <FaFacebookF className="shareIcon" />
        </button>
      </div>
      <div className="section2 show">
        <button className="sharebutton" onClick={shareClick}>
          <FiShare2 className="shareIcon" />
        </button>
      </div>
      <div className={`section3 ${showShareOption ? "show" : "hide"}`}>
        <button className="twittericon" onClick={shareToTwitter}>
          <FaXTwitter className="shareIcon" />
        </button>
      </div>
      <div className={`section4 ${showShareOption ? "show" : "hide"}`}>
        <button className="copybutton" onClick={copyLink}>
          <FaCopy className="shareIcon" />
        </button>
      </div>
    </div>
  );
}

export default ShareButton;
